export default "__VITE_ASSET__BVuBuxrh__"